const SDK_URL = "https://sdk.mercadopago.com/js/v2";
const POLL_MS = 50;
const MAX_POLLS = 200;

export function loadMercadoPagoSdk(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.MercadoPago) {
      resolve();
      return;
    }
    const existing = document.querySelector('script[src*="sdk.mercadopago.com"]');
    if (existing) {
      let attempts = 0;
      const check = () => {
        if (window.MercadoPago) { resolve(); return; }
        if (++attempts > MAX_POLLS) { reject(new Error("MercadoPago SDK timeout")); return; }
        setTimeout(check, POLL_MS);
      };
      check();
      return;
    }
    const script = document.createElement("script");
    script.src = SDK_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load MercadoPago SDK"));
    document.head.appendChild(script);
  });
}
